import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { INPUT_AUTOCOMPLETE_VALUE } from '../../../constants/common'
import { preventDefault, stopPropagation } from '../../../utils/events'
import Button, { BUTTON_HEIGHT_24 } from '../../Button'
import { InputTypeValue } from '../Input.constants'
import { isInputTypeValuePassword } from '../Input.utils'
import { InputField } from '../InputField'

import * as styles from './PasswordInput.module.css'

import ClosedEye from '../../../icons/closed-eye.svg'
import OpenEye from '../../../icons/open-eye.svg'

function PasswordInput({
  autoComplete = INPUT_AUTOCOMPLETE_VALUE.off,
  ...props
}) {
  const { t } = useTranslation()

  const [type, setType] = useState(InputTypeValue.Password)

  const ref = useRef(null)

  function handleShowPassword(event) {
    preventDefault(event)
    stopPropagation(event)

    setType(InputTypeValue.Text)
  }

  function handleHidePassword(event) {
    preventDefault(event)
    stopPropagation(event)

    setType(InputTypeValue.Password)
  }

  const afterButtonProps = isInputTypeValuePassword(type)
    ? {
        beforeIconProps: { Icon: ClosedEye },
        tooltip: t('Common.PasswordInputShowPasswordBtnTooltipKey'),
        onMouseDown: handleShowPassword,
      }
    : {
        beforeIconProps: { Icon: OpenEye },
        tooltip: t('Common.PasswordInputHidePasswordBtnTooltipKey'),
        onMouseDown: handleHidePassword,
      }

  return (
    <InputField
      {...props}
      afterButton={
        <Button.Text
          {...afterButtonProps}
          isGrey
          className={styles.button}
          height={BUTTON_HEIGHT_24}
        />
      }
      autoComplete={autoComplete}
      ref={ref}
      type={type}
    />
  )
}

export default PasswordInput
